import { Component, OnInit } from '@angular/core';
import {StripeService} from 'ngx-stripe';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-payment-success-view',
  templateUrl: './payment-success-view.component.html',
  styleUrls: ['./payment-success-view.component.scss']
})
export class PaymentSuccessViewComponent implements OnInit {
  response = 'Your payment has been processed.';
  private clientSecret: any;
  constructor(private activatedRoute: ActivatedRoute, private stripeService: StripeService) {
    this.activatedRoute.queryParams
      .subscribe(params => {
          this.clientSecret = params.payment_intent_client_secret;
        }
      );
  }
  ngOnInit(): void {
    // Retrieve the PaymentIntent
    this.stripeService.retrievePaymentIntent(this.clientSecret).subscribe(PaymentIntentResult => {

      switch (PaymentIntentResult.paymentIntent.status ) {
        case 'succeeded':
          this.response = 'Your payment has been processed.';
          break;

        case 'processing':
          this.response = 'Payment processing. We\'ll update you when payment is received.';
          break;

        case 'requires_payment_method':
          this.response = 'Payment failed. Please try another payment method.';
          // Redirect your user back to your payment page to attempt collecting
          // payment again
          break;

        default:
          this.response = 'Something went wrong.';
          break;
      }

    }, () => {
      this.response = 'Something went wrong.';

    });
  }

}
